import React, { useCallback, useMemo, useState } from "react";
import {
    AvatarQuality,
    ElevenLabsModel,
    STTProvider,
    VoiceEmotion,
    StartAvatarRequest,
    VoiceChatTransport,
} from "@heygen/streaming-avatar";
import styles from "./AvatarCongig.module.scss";

import { Input } from "@/shared/ui/Input";
import { Select } from "@/shared/ui/Select";

import { Field } from "./Field";

import { AVATARS, STT_LANGUAGE_LIST } from "@/shared/const/avatar";

interface AvatarConfigProps {
    onConfigChange: (config: StartAvatarRequest) => void;
    config: StartAvatarRequest;
}

export const AvatarConfig: React.FC<AvatarConfigProps> = ({
    onConfigChange,
    config,
}) => {
    const [collapsed, setCollapsed] = useState(false);
    const [selectedAvatarId, setSelectedAvatarId] = useState("");
    const [selectedLang, setSelectedLang] = useState("");

    const onChange = <T extends keyof StartAvatarRequest>(
        key: T,
        value: StartAvatarRequest[T],
    ) => {
        onConfigChange({ ...config, [key]: value });
    };
    const selectedAvatar = useMemo(() => {
        const avatar = AVATARS.find(
            (avatar) => avatar.avatar_id === config.avatarName,
        );

        if (!avatar) {
            return {
                isCustom: true,
                name: "Custom Avatar ID",
                avatarId: null,
            };
        } else {
            return {
                isCustom: false,
                name: avatar.name,
                avatarId: avatar.avatar_id,
            };
        }
    }, [config.avatarName]);

    const handleChangeAvatar = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            const avatarId = e.target.value;
            setSelectedAvatarId(avatarId);
        },
        [],
    );

    const handleChangeLang = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            const lang = e.target.value;
            setSelectedLang(lang);
        },
        [],
    );

    return (
        <div className={styles.wrapper}>
            <button
                className={styles.toggleButton}
                onClick={() => setCollapsed(!collapsed)}
            >
                {collapsed
                    ? "Show Avatar Settings ▼"
                    : "Hide Avatar Settings ▲"}
            </button>
            <div
                className={`${styles.configContainer} ${collapsed ? styles.collapsed : ""}`}
            >
                <Field label="Custom Knowledge Base ID">
                    <Input
                        placeholder="Enter custom knowledge base ID"
                        value={config.knowledgeId}
                        onChange={(value) => onChange("knowledgeId", value)}
                    />
                </Field>
                <Field label="Avatar ID">
                    <Select
                        selectedValue={selectedAvatarId}
                        options={AVATARS.map((option) => ({
                            label: option.name,
                            value: option.avatar_id,
                        }))}
                        // placeholder="Select Avatar"
                        onChange={handleChangeAvatar}
                    />
                </Field>
                <Field label="Language">
                    <Select
                        options={STT_LANGUAGE_LIST}
                        onChange={handleChangeLang}
                        selectedValue={selectedLang}
                    />
                </Field>

                {/*<Field label="Voice Chat Transport">*/}
                {/*    <Select*/}
                {/*        isSelected={(option) =>*/}
                {/*            option === config.voiceChatTransport*/}
                {/*        }*/}
                {/*        options={Object.values(VoiceChatTransport)}*/}
                {/*        renderOption={(option) => option}*/}
                {/*        value={config.voiceChatTransport}*/}
                {/*        onSelect={(option) =>*/}
                {/*            onChange("voiceChatTransport", option)*/}
                {/*        }*/}
                {/*    />*/}
                {/*</Field>*/}
            </div>
        </div>
    );
};
